import { graphql } from '../../../graphql/generated';

export const DIAGNOSES_QUERY = graphql(`
  query Diagnoses($labId: ID!) {
    labDiagnoses(labId: $labId) {
      id
      name
      text
      icd10
    }
  }
`);
